// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2_WZ5","errors":"Errors_errors__4TYYH"};